<!-- ⚠️ Warning Banner -->
<div class="warning-banner" *ngIf="showWarning">
	<i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
	<span>{{ alert.alertDescription }}</span>
	<button class="close-btn btn" (click)="closeWarning()"><i class="fa fa-close"></i></button>
</div>
<div class="header">
	<a [href]="logoLink" target="_blank" rel="noopener noreferrer">
		<img [src]="src" alt="ArrowXL Logo" class="logo" />
	</a>
	<button class="btn" (click)="onFaq()">{{ deliveryConstants.btnFaq }}</button>
</div>

